var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2CC9",
    fillRule: "evenodd",
    d: "M.9 7.712a.75.75 0 0 1 .75.75v4.07c0 .335.272.607.607.607h9.497a.607.607 0 0 0 .607-.607v-4.07a.75.75 0 1 1 1.5 0v4.07a2.107 2.107 0 0 1-2.107 2.107H2.257A2.107 2.107 0 0 1 .15 12.532v-4.07a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2CC9",
    fillRule: "evenodd",
    d: "M7.005.25a.75.75 0 0 1 .75.75v7.572l2.09-2.275a.75.75 0 0 1 1.104 1.014l-3.392 3.693a.75.75 0 0 1-1.104 0L3.06 7.311a.75.75 0 0 1 1.105-1.015l2.09 2.276V1a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};
export default SvgDownload;